export default "__VITE_ASSET__DUNl68j6__"